var _desc;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPadelboxLogoQuadradoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 446.1 446.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 6.7.1")), /*#__PURE__*/React.createElement("g", {
    id: "glyphGroup_textPair_1762774113368_0.40398241715515093"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.2,98.66c-7.03-7.17-16.98-10.83-30.01-10.83h-41.57v114.33h23.13v-92.37h16.98c5.71,0,10.25,1.17,13.17,3.81,2.93,2.49,4.25,6.44,4.25,11.42s-1.32,8.64-3.95,11.13c-3.51,3.07-8.64,4.39-15.52,4.39h-2.34l-9.51,21.96h13.17c5.86,0,11.27-.73,16.1-2.2,5.42-1.46,9.66-3.81,13.61-6.73,3.81-3.37,6.88-7.32,8.93-12,2.05-4.68,3.07-10.25,3.07-16.25,0-11.13-3.22-20.2-9.51-26.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.52,124.28c-5.71-3.07-12.15-4.54-18.59-4.54-5.86,0-11.27,1.02-16.25,3.22-4.98,2.2-9.66,5.12-13.47,9.08-3.66,3.66-6.88,8.05-8.78,13.03-2.2,5.42-3.37,10.83-3.37,16.39s1.17,11.13,3.37,16.25c1.9,4.98,5.12,9.51,8.78,13.17,3.81,3.95,8.49,7.03,13.47,9.08,4.98,2.2,10.39,3.22,16.25,3.22,6.29,0,12.88-1.46,18.59-4.39v3.37h22.1v-45.23c0-22.25-22.1-32.64-22.1-32.64ZM182.54,186.93l-6.44-10.83c-1.02,1.02-2.2,1.76-3.22,2.49-3.07,1.76-6.59,2.63-9.95,2.63-11.13,0-19.91-8.78-19.91-19.76s8.78-19.76,19.91-19.76c3.66,0,7.47,1.02,10.54,3.22,3.07,2.05,5.56,4.83,7.17,8.2,1.32,2.63,1.9,5.42,1.9,8.49v25.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.77,161.47c0-5.56,1.02-11.13,3.22-16.25,2.05-4.98,5.12-9.37,8.93-13.32,3.81-3.81,8.34-6.73,13.32-8.93,5.12-2.05,10.54-3.22,16.25-3.22s10.98,1.17,16.25,3.22l3.51,1.76v-41.72l21.96,7.32v71.15c0,5.56-1.17,11.13-3.37,16.25-2.05,4.98-5.12,9.37-8.93,13.32-3.81,3.81-8.34,6.73-13.18,8.93-5.27,2.05-10.69,3.22-16.25,3.22s-11.13-1.17-16.25-3.22c-4.98-2.2-9.52-5.12-13.32-8.93-3.81-3.95-6.88-8.34-8.93-13.32-2.2-5.12-3.22-10.69-3.22-16.25ZM251.49,181.23c10.83,0,19.76-8.93,19.76-19.76s-8.93-19.76-19.76-19.76-19.76,8.93-19.76,19.76,8.78,19.76,19.76,19.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.6,190.6c-7.76-7.76-12.15-18.15-12.15-29.13s4.39-21.37,12.15-29.28c7.76-7.76,18.15-12,29.13-12s21.37,4.25,29.13,12c7.91,7.91,12.15,18.15,12.15,29.28v10.54h-58.27c3.66,5.71,9.81,9.37,16.98,9.37,5.56,0,10.83-2.2,14.64-6.29l15.37,14.64c-3.81,4.1-8.34,7.17-13.32,9.52-5.27,2.2-10.83,3.37-16.69,3.37-10.98,0-21.37-4.25-29.13-12ZM355.72,150.78c-3.51-5.56-9.81-9.37-16.98-9.37s-13.32,3.81-16.98,9.37h33.96Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.83,84.17v118h-22.11v-110.68l22.11-7.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.01,303.81c-2.05-2.34-4.68-4.39-7.76-6,2.05-1.61,3.95-3.66,5.42-6,3.22-4.98,4.83-10.69,4.83-16.98,0-4.98-1.17-9.66-3.07-13.47-1.76-3.95-4.54-7.47-8.34-10.1-6.59-4.54-15.81-6.88-27.23-6.88h-39.23v114.33h43.04c12.59,0,22.69-3.07,29.72-9.22,6.59-5.86,10.25-14.2,10.25-24.15,0-8.34-2.63-15.66-7.61-21.52ZM92.81,333.53c-2.93,2.2-7.47,3.37-13.17,3.37h-18.88v-70.56l14.64-.15c6.29,0,10.69,1.17,13.61,3.37.73.44,3.22,2.63,3.22,7.76,0,4.25-1.46,7.17-4.1,9.22-2.63,1.76-6.44,2.78-11.13,2.78h-13.47l10.1,21.37h3.95c6.73,0,12,1.32,15.08,3.81,2.93,2.34,4.39,5.42,4.39,9.81,0,3.95-1.46,7.17-4.25,9.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.97,358.71h-25.91l29.57-41.28-29.72-40.26h26.79l15.96,22.54,16.25-22.54h26.64l-29.57,40.41,29.87,41.14h-26.21l-16.84-22.55-16.84,22.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "vectorized-icon-undefined"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.35,318.53c0,11.02-4.67,21.62-13.16,28.82,0,0-.42,0-.42.42-7.22-7.63-11.88-17.8-11.88-29.25s4.67-21.62,11.88-29.25l.42.42c8.49,7.21,13.16,17.8,13.16,28.82Z",
    style: {
      fill: "#c6ff00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,353.29c-6.79,4.66-15.28,7.63-24.19,7.63s-17.4-2.97-24.19-7.63c10.19-8.9,15.7-21.62,15.7-34.76s-5.52-25.86-15.7-34.76c6.79-4.66,15.28-7.63,24.19-7.63s17.4,2.97,24.19,7.63c-10.19,8.9-15.7,21.19-15.7,34.76s5.52,25.86,15.7,34.76Z",
    style: {
      fill: "#c6ff00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.77,318.53c0,11.44-4.67,21.62-11.88,29.25l-.42-.42c-8.49-7.21-13.58-17.8-13.58-28.82s5.09-21.62,13.58-28.82l.42-.42c7.22,7.63,11.88,17.8,11.88,29.25Z",
    style: {
      fill: "#c6ff00"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "385.58 446.57 446.1 446.57 446.1 446.56 446.1 386.15 430.76 386.15 430.76 431.23 385.58 431.23 385.58 446.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.58 0 385.58 15.33 430.76 15.33 430.76 60.87 446.1 60.87 446.1 0 385.58 0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.34 431.23 15.33 431.23 15.33 431.23 15.33 386.15 0 386.15 0 446.57 60.34 446.57 60.34 431.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.34 0 0 0 0 60.87 15.33 60.87 15.33 15.33 60.34 15.33 60.34 0",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadelboxLogoQuadradoWhite);
export default __webpack_public_path__ + "static/media/padelbox_logo_quadrado_white.deb14b96153c34e2a7df23cb6c293a97.svg";
export { ForwardRef as ReactComponent };